module.exports = __webpack_public_path__ + "15_ldav_slides.pdf?4d53a86188b67187e59ba4f8e0d61ffb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperData/15_ldav_slides.pdf
// module id = 142
// module chunks = 0